import * as React from 'react';

const SectionCenterSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="section-center_svg__eds-icon--section-center_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="section-center_svg__eds-icon--section-center_base"
            fill="#010101"
            d="M9 17h6v2H9v-2zm-1 3h8v-4H8v4z"
        />
        <path
            id="section-center_svg__eds-icon--section-center_middle"
            fill="#010101"
            d="M4 10v4h16v-4H4zm15 3H5v-2h14v2z"
        />
        <path
            id="section-center_svg__eds-icon--section-center_top_1_"
            fill="#010101"
            d="M4 4v4h16V4H4zm15 3H5V5h14v2z"
        />
    </svg>
);

SectionCenterSvg.displayName = 'SectionCenterSvg';
export default SectionCenterSvg;
